import Work from './components/Work';
import About from './components/About';
import Contact from './components/Contact';

function App() {
  return (
    <div className="min-h-screen bg-white">
      <main id="top" className="mx-auto max-w-[680px] px-6 pb-20 pt-16 sm:px-8">
        <header className="flex flex-col items-start gap-3">
          <img
            src="/zoomed_in_personal_pic2.jpeg"
            alt="Ayushi Nanavati"
            className="h-16 w-16 shrink-0 border border-gray-300 object-cover"
          />
          <div>
            <h1 className="font-mono text-base text-black">Ayushi Nanavati</h1>
            {/* <p className="mt-2 font-mono text-sm leading-[1.7] text-gray-600">
              AI Engineer • Mumbai
              <br />
              Available for contract work ($35-50/hr)
            </p> */}
          </div>
        </header>

        <section className="mt-8">
          <About />
        </section>

        <section className="mt-12">
          <details className="group">
            <summary className="min-h-[44px] cursor-pointer py-2 font-mono text-sm text-black focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white">
              <span className="select-none">
                [[Work]] 
                {/* <span className="group-open:hidden"></span> */}
                {/* <span className="hidden group-open:inline"></span> */}
              </span>
            </summary>
            <div className="mt-2">
              <Work />
            </div>
          </details>
        </section>

        <section className="mt-2" id="contact">
          <details className="group">
            <summary className="min-h-[44px] cursor-pointer py-2 font-mono text-sm text-gray-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white">
              <span className="select-none">
                [[Contact]] 
                {/* <span className="group-open:hidden"></span> */}
                {/* <span className="hidden group-open:inline"></span> */}
              </span>
            </summary>
            <div className="mt-2">
              <Contact />
            </div>
          </details>
        </section>
      </main>
    </div>
  );
}

export default App;
